<div class="submission-btn" [formGroup]="group">
    <button [ngClass]="{'disabled': field.disabled}" [disabled]="field.disabled" type="submit" class="btn submitSub-btn all-btns"> {{field.label}}</button>
  </div>